import React from 'react';
import { summarizeLineup } from '../utils/lineupAnalysis';

export default function LineupAnalysisPanel({
  forwards,
  defensemen,
  lineupGoalies,
  totalSalary,
  salaryCap,
}) {
  const summary = summarizeLineup(forwards, defensemen, lineupGoalies);
  const { typeBalance, avgAge, avgOv, totalCount } = summary;
  const typedTotal = typeBalance.T + typeBalance.P + typeBalance.S;
  const capPct = salaryCap > 0 ? Math.min((totalSalary / salaryCap) * 100, 100) : 0;
  const overCap = totalSalary > salaryCap;

  if (totalCount === 0) {
    return (
      <div className="lineup-analysis-panel empty">
        <h3>Lineup overview</h3>
        <p>Add players to see type balance, age, and OV averages.</p>
      </div>
    );
  }

  return (
    <div className="lineup-analysis-panel">
      <div className="lineup-analysis-header">
        <h3>Lineup overview</h3>
        <span className="lineup-analysis-count">{totalCount} players</span>
      </div>

      <div className="lineup-analysis-grid">
        <div className="lineup-analysis-stat">
          <span className="lineup-analysis-label">Avg age</span>
          <span className="lineup-analysis-value">{avgAge ?? '—'}</span>
        </div>
        <div className="lineup-analysis-stat">
          <span className="lineup-analysis-label">Avg OV</span>
          <span className="lineup-analysis-value">{avgOv ?? '—'}</span>
        </div>
        <div className="lineup-analysis-stat">
          <span className="lineup-analysis-label">Cap used</span>
          <span className={`lineup-analysis-value ${overCap ? 'over' : ''}`}>
            {Math.round(capPct)}%
          </span>
        </div>
      </div>

      <div className="lineup-type-balance">
        <div className="lineup-type-balance-header">
          <span>Type balance</span>
          <span className="lineup-analysis-muted">{typedTotal} typed skaters</span>
        </div>
        <div className="lineup-type-bars">
          {[
            { key: 'T', label: 'Transport', cls: 'type-t' },
            { key: 'P', label: 'Playmaker', cls: 'type-p' },
            { key: 'S', label: 'Scorer', cls: 'type-s' },
          ].map(({ key, label, cls }) => {
            const count = typeBalance[key];
            const width = typedTotal > 0 ? (count / typedTotal) * 100 : 0;
            return (
              <div key={key} className="lineup-type-row">
                <span className={`lineup-type-pill ${cls}`}>{key}</span>
                <div className="lineup-type-track">
                  <div className={`lineup-type-fill ${cls}`} style={{ width: `${width}%` }} />
                </div>
                <span className="lineup-type-count" title={label}>
                  {count}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export function LineChemistryBadge({ chemistry }) {
  if (!chemistry) return null;
  return (
    <span className={`line-chemistry-badge tone-${chemistry.tone}`} title="Line chemistry from T/P/S mix">
      {chemistry.label}
    </span>
  );
}
